function findAssociatedLabel(element: HTMLElement): string | undefined {
  // Skip textContent for form input elements (select, textarea)
  // These elements contain user data or options that shouldn't be treated as labels
  const skipTextContent =
    element instanceof HTMLSelectElement || element instanceof HTMLTextAreaElement;

  // Direct text content (skip for select/textarea)
  if (!skipTextContent && element.textContent) {
    return element.textContent.trim();
  }

  // For input button/submit elements specifically, check the value attribute
  // (but not for checkbox/radio/text inputs which have different semantics)
  if (
    element instanceof HTMLInputElement &&
    (element.type === 'button' || element.type === 'submit') &&
    element.value
  ) {
    return element.value.trim();
  }

  // aria-label
  const ariaLabel = element.getAttribute('aria-label');
  if (ariaLabel) {
    return ariaLabel.trim();
  }

  // <label for="id">
  if (element.id) {
    const label = document.querySelector(`label[for="${element.id}"]`);
    if (label) return label.textContent?.trim();
  }

  // Wrapped in <label>
  // TODO: check if this actually works in the case where we use label as a wrapper (BooleanFilterInterface)
  const parentLabel = element.closest('label');
  if (parentLabel) {
    const clone = parentLabel.cloneNode(true) as HTMLElement;
    clone.querySelectorAll('input, select, textarea').forEach((el) => el.remove());
    return clone.textContent?.trim() || undefined;
  }
}

export default findAssociatedLabel;
